import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { classToPlain, plainToClass } from 'class-transformer';
import 'rxjs/add/observable/interval';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/takeLast';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/takeWhile';
import { Observable } from 'rxjs/Observable';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { History } from './../data/data';

@Injectable()
export class DataProvider {

    public history: History = null;

    constructor(
        private storage: Storage
    ) {
    }

    public load(): Observable<History> {
        if (this.history != null) {
            return Observable.of(this.history);
        }
        return fromPromise(this.storage.get('history'))
            .map(history => {
                if (history) {
                    this.history = plainToClass<History, Object>(History, history);
                    if (this.history.version < 2) {
                        this.history = null;
                    }
                }

                if (this.history == null) {
                    this.history = new History();
                }
                return this.history;
            });
    }

    public save(): Promise<any> {
        const obj = classToPlain(this.history);
        return this.storage.set('history', obj);
    }

    public clear(): void {
        this.history.clear();
        this.save();
    }
}



// WEBPACK FOOTER //
// ./src/provider/data-service.ts